import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["submission", "assignment", "open", "isLoadingGetSubmission", "translations"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AppModal } from '@lib/common';
import { Skeleton } from 'antd';
import styled from 'styled-components';
import { TableViolate } from '../table-violate-submission';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledTitle = styled.div.withConfig({
  displayName: "violate-submissionmodal__StyledTitle",
  componentId: "sc-17246v0-0"
})(["font-weight:700;font-size:24px;"]);
var StyledModalHeaderLayout = styled.div.withConfig({
  displayName: "violate-submissionmodal__StyledModalHeaderLayout",
  componentId: "sc-17246v0-1"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;"]);
var StyledGroupButton = styled.div.withConfig({
  displayName: "violate-submissionmodal__StyledGroupButton",
  componentId: "sc-17246v0-2"
})(["display:flex;align-items:center;gap:8px;"]);
export var ViolateSubmissionModal = function ViolateSubmissionModal(_ref) {
  var submission = _ref.submission,
      assignment = _ref.assignment,
      open = _ref.open,
      isLoadingGetSubmission = _ref.isLoadingGetSubmission,
      translations = _ref.translations,
      props = _objectWithoutProperties(_ref, _excluded);

  var violateTranslation = {
    violateTime: translations.violateTime,
    violateType: translations.violateType,
    violateCopyPaste: translations.violateCopyPaste,
    violateSwitchTab: translations.violateSwitchTab
  };

  var renderTableContent = function renderTableContent() {
    if (isLoadingGetSubmission) {
      return /*#__PURE__*/_jsx(Skeleton, {
        paragraph: {
          rows: 4
        },
        active: true
      });
    }

    return /*#__PURE__*/_jsx(TableViolate, {
      submission: submission,
      violateTranslation: violateTranslation
    });
  };

  return /*#__PURE__*/_jsxs(AppModal, _objectSpread(_objectSpread({}, props), {}, {
    open: open,
    cancelText: translations.close,
    okButtonProps: {
      style: {
        display: 'none'
      }
    },
    width: 890,
    closable: true,
    destroyOnClose: true,
    centered: true,
    children: [/*#__PURE__*/_jsx(StyledModalHeaderLayout, {
      children: /*#__PURE__*/_jsx(StyledGroupButton, {
        children: /*#__PURE__*/_jsx(StyledTitle, {
          children: translations.violateDetail
        })
      })
    }), renderTableContent()]
  }));
};